import styled from '@emotion/styled'
import type { FC } from 'react'

import type { Option } from '@segment/matcha/components/Menu/useMenu'
import type { UseSelectProps } from '@segment/matcha/components/Select/useSelect'
import useSelect from '@segment/matcha/components/Select/useSelect'
import SelectBase, * as Select from '@segment/matcha/components/Select'
import { ChevronDownIcon, ClearIcon } from '@segment/matcha/components/Icons/Common'
import Input from '@segment/matcha/components/Input'

interface FilterSelectProps {
  id: string
  options: Option[]
  onSelect: UseSelectProps[`onSelect`]
  placeholder: string
}

const FilterSelect: FC<FilterSelectProps> = ({ id, options, onSelect, placeholder }) => {
  const { state, filteredOptions, getControlProps, getSelectProps } = useSelect({
    options,
    id,
    onSelect,
    config: {
      mobileConfirmationBehaviour: true,
      multiselect: true,
    },
    label: placeholder,
  })

  const selectId = `${id}-select`

  return (
    <Wrapper>
      <Input
        name={id}
        type="search"
        resetable={state.filterValue !== ``}
        clearIcon={
          <Select.ClearSelect>
            <ClearIcon size="small" />
          </Select.ClearSelect>
        }
        rightSecondIcon={<ChevronDownIcon />}
        {...getControlProps({ placeholder, counter: true })}
      />
      <SelectBase
        id={selectId}
        name={selectId}
        open={state.open}
        options={options}
        filteredOptions={filteredOptions}
        displayMode={state.displayMode}
        listItemComponent={Select.MenuItemWithCheckbox}
        {...getSelectProps()}
      />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  z-index: 2;
`

export default FilterSelect
